// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HmBH","tabsBox":"styles_tabsBox__32NwP","createButton":"styles_createButton__1og3o"};